module.exports = __webpack_public_path__ + "img/cancel_icon.1fdfb7ae.svg";